/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential. Unauthorised use, reproduction or distribution
 * of this software, in whole or in part, is strictly prohibited.
 * See LICENSE.txt for full terms.
 */

// v1_864: THE FACT PACK SAYS WHAT EACH DOCUMENT STATES.
// The draft rationale said the Memorandum of Association confirmed a 100
// percent holding (walk wbb7f80b1, 29/09/26). The memorandum names the parent as
// a subscriber and states no percentage. The fact pack passed each ownership leg
// with its percentage field as written ("not stated (subscriber to at least one
// share)") beside the register's leg for the same holder and company ("100").
// Once v1_862 read both holders to the same name, the drafter merged the two
// legs and cited both documents for the 100. Each leg now carries a sentence of
// what its document states, a percentage only where the document gives one, and
// the drafter is told to cite a document for a percentage only on that basis.

const clean = (v) => String(v == null ? '' : v).replace(/\s+/g, ' ').trim();

// A percentage the entry states: a number, with any band words kept ("75
// percent or more"). Anything else (a description, "not stated") is no
// percentage.
export function statedPercentage(p) {
  const t = clean(p);
  return /^\d+(?:\.\d+)?\s*(?:%|percent\b|per cent\b)?/i.test(t) ? t.replace(/\s*%/, ' percent') : null;
}

export function factPackOwnershipLegs(legs) {
  return (Array.isArray(legs) ? legs : []).filter(Boolean).map((l) => {
    const holder = clean(l.holder || l.entity);
    const held = clean(l.held || l.holds);
    const source = clean(l.source) || 'The file';
    const raw = clean(l.percentage);
    const pct = statedPercentage(raw);
    const pctWords = pct && /percent|per cent/i.test(pct) ? pct : (pct ? pct + ' percent' : null);
    return {
      holder, held,
      percentage: pct,
      source,
      documentStates: pct
        ? `${source} states that ${holder} holds ${pctWords} of ${held}.`
        : `${source} names ${holder} in relation to ${held}${raw ? ' ("' + raw + '")' : ''}. It states no percentage.`,
    };
  });
}

// Figures the client stated. The financial ranges are the client's own
// indication at pre screening; the source of wealth and funds narratives are
// the platform's assessment written from the documents and the conversation,
// so a figure in them is the client's statement unless the narrative names the
// document that evidences it.
export const CLIENT_STATED_FIGURES_NOTE = 'Every figure in financialRanges was indicated by the client and is not evidenced. A turnover, revenue, profit, asset, volume or wealth figure in sowNarrative or sofNarrative is as the client stated unless that narrative names the document that evidences it; say so when you use it.';

export default factPackOwnershipLegs;
